<template>
  <div
    class="men-one-page-signup"
    :class="{
      'two-for-one-campaign': showTwoForOneCampaign,
      'with-design-choice': isOnePagerWithDesignChoice,
      'is-women-one-pager': isWomenOnePager,
      'is-women-one-pager-with-design-choice': isWomenOnePagerWithDesignChoice
    }"
  >
    <div class="relative text-gray-600">
      <SignUpLayoutBox
        class="mb-40"
        background-color="#F7F7F7"
        :hide-steps="false"
      >
        <div v-if="showTwoForOneCampaign" class="banner-container bg-black text-white font-display overflow-hidden">
          <div class="banner-content flex items-center font-extrabold text-sm uppercase py-2">
            <span class="inline-block w-2 h-2 rounded-lg bg-white mx-2 flex-shrink-0" />
            <span class="whitespace-no-wrap" v-text="getTranslation('Campaign.TwoForOne.Banner')" />
            <span class="inline-block w-2 h-2 rounded-lg bg-white mx-2 flex-shrink-0" />
            <span class="whitespace-no-wrap" v-text="getTranslation('Campaign.TwoForOne.Banner')" />
            <!-- Duplicate content for seamless loop -->
            <span class="inline-block w-2 h-2 rounded-lg bg-white mx-2 flex-shrink-0" />
            <span class="whitespace-no-wrap" v-text="getTranslation('Campaign.TwoForOne.Banner')" />
            <span class="inline-block w-2 h-2 rounded-lg bg-white mx-2 flex-shrink-0" />
            <span class="whitespace-no-wrap" v-text="getTranslation('Campaign.TwoForOne.Banner')" />
            <!-- Duplicate content for seamless loop -->
            <span class="inline-block w-2 h-2 rounded-lg bg-white mx-2 flex-shrink-0" />
            <span class="whitespace-no-wrap" v-text="getTranslation('Campaign.TwoForOne.Banner')" />
            <span class="inline-block w-2 h-2 rounded-lg bg-white mx-2 flex-shrink-0" />
            <span class="whitespace-no-wrap" v-text="getTranslation('Campaign.TwoForOne.Banner')" />
          </div>
        </div>
        <div v-if="isWomenOnePager" class="women-hero-image-container relative">
          <OImage
            v-bind="heroImage"
            :alt="$t('Accessibilty.AltTags.WomenOnePagerImage')"
            img-class="w-full h-full relative pointer-events-none mx-auto"
          />
          <p class="font-extrabold font-display product-image-text" v-text="productImageText" />
        </div>
        <div v-else class="product-image-container relative">
          <div v-if="!isSpecialDesign" class="w-1/2 absolute first-half left-0 top-0 h-full bottom-0" :style="{ backgroundColor: designColors.primaryColor }" />
          <div v-if="!isSpecialDesign" class="w-1/2 absolute right-0 top-0 h-full bottom-0" :style="{ backgroundColor: designColors.primaryColor }" />
          <OImage
            v-if="isSpecialDesign"
            v-bind="specialDesignHeroImage"
            :alt="$t('Accessibilty.AltTags.PhotoOfTheDesignWithName', { name: designSlug })"
            img-class="w-full special-design-hero-header h-full relative pointer-events-none absolute top-0 right-0 left-0 bottom-0 object-cover"
          />
          <div class="relative z-10">
            <CountdownTimer
              :class="['ota-countdown-timer hidden', {
                'lg:hidden': isWomenOnePager,
                'lg:flex': !isWomenOnePager
              }]"
              :time-remaining="timeRemaining"
              :filler-width="fillerWidth"
              :title="getTranslation('LimitedOffer')"
              :description="countdownIsExpired ? getTranslation('ReserveExpired') : $t('SignUp.OnePage.HurryFewLeft', variables)"
            />
            <div class="max-w-375 relative">
              <OImage
                v-if="showTwoForOneCampaign"
                v-bind="mysteryImage"
                img-class="w-full h-full object-contain mystery-image pointer-events-none mx-auto"
                :alt="$t('Accessibilty.AltTags.MysteryImage')"
              />
              <OImage
                v-bind="productImage"
                img-class="w-full h-full relative product-image pointer-events-none mx-auto"
                :alt="$t('Accessibilty.AltTags.PhotoOfTheDesignWithName', { name: designSlug })"
              />
              <OSvg v-if="showTwoForOneCampaign" svg="new-big-plus-icon" class="plus-icon" />
              <p class="font-extrabold font-display product-image-text" v-text="productImageText" />
            </div>
          </div>
        </div>
        <div class="lg:px-10">
          <div
            :class="['negative-margin px-4 relative z-20', {
              'lg:px-0': isWomenOnePager
            }]"
          >
            <CountdownTimer
              :class="['ota-countdown-timer', {
                'lg:hidden': !isWomenOnePager
              }]"
              :time-remaining="timeRemaining"
              :filler-width="fillerWidth"
              :title="getTranslation('LimitedOffer')"
              :description="countdownIsExpired ? getTranslation('ReserveExpired') : $t('SignUp.OnePage.HurryFewLeft', variables)"
            />
          </div>
          <section
            :class="['text-sm px-4 lg:px-0', {
              'lg:pt-24 mt-10': !isWomenOnePager,
              'mt-9': isWomenOnePager
            }]"
          >
            <div class="flex items-center text-sm mb-rem">
              <div class="super-box">
                <OImage
                  v-bind="productImage"
                  :alt="$t('Accessibilty.AltTags.PhotoOfTheDesignWithName', { name: designSlug })"
                />
              </div>
              <div class="pl-rem flex flex-col">
                <p class="font-display font-bold" v-text="isWomenOnePager ? $t('Sizechart.TopSizeChart.Title') : capitalize(variables.product)" />
                <p class="font-body flex flex-row items-center">
                  <OSvg svg="labelsvg" class="fill-neutral-600 mr-1" />
                  <span class="text-neutral-600" v-text="designName" />
                  <span v-if="isSpecialDesign" class="font-display font-extrabold block ml-2 text-xs text-white bg-orange-600 rounded-sm px-2" v-text="$t('SpecialDesigns.general.SpecialEdition')" />
                </p>
              </div>
              <div class="ml-auto flex flex-col text-right">
                <p class="font-display font-normal line-through" v-text="formattedPrice" />
                <p class="font-display font-extrabold text-green-400" v-text="formattedFreePrice" />
              </div>
            </div>
            <div v-if="isWomenOnePager" class="flex items-center text-sm mb-rem">
              <div class="super-box">
                <OImage
                  v-bind="secondaryProductImage"
                  :alt="$t('Accessibilty.AltTags.PhotoOfTheDesignWithName', { name: secondaryDesignSlug })"
                />
              </div>
              <div class="pl-rem flex flex-col">
                <div class="flex flex-row items-center">
                  <p class="font-display font-bold pr-2" v-text="capitalize(variables.product)" />
                </div>
                <p class="font-body flex flex-row items-center">
                  <OSvg svg="labelsvg" class="fill-neutral-600 mr-1" />
                  <span class="text-neutral-600" v-text="capitalize(secondaryDesignSlug)" />
                </p>
              </div>
              <div class="ml-auto flex flex-col text-right">
                <p class="font-display font-normal line-through" v-text="formattedPrice" />
                <p class="font-display font-extrabold text-green-400" v-text="formattedFreePrice" />
              </div>
            </div>
            <div v-if="showTwoForOneCampaign" class="flex items-center text-sm mb-rem">
              <div class="super-box">
                <OImage
                  v-bind="mysteryImage"
                  :alt="$t('Accessibilty.AltTags.MysteryImage')"
                />
              </div>
              <div class="pl-rem flex flex-col">
                <div class="flex flex-row items-center">
                  <p class="font-display font-bold pr-2" v-text="variables.product" />
                  <p class="font-display font-extrabold text-xs text-white bg-orange-500 rounded-sm px-2" v-text="getTranslation('Campaign.TwoForOne.Label')" />
                </div>
                <p class="font-body flex flex-row items-center">
                  <OSvg svg="labelsvg" class="fill-neutral-600 mr-1" />
                  <span class="text-neutral-600" v-text="getTranslation('Campaign.TwoForOne.LineItemText')" />
                </p>
              </div>
              <div class="ml-auto flex flex-col text-right">
                <p class="font-display font-normal line-through" v-text="formattedPrice" />
                <p class="font-display font-extrabold text-green-400" v-text="formattedFreePrice" />
              </div>
            </div>
            <div class="flex text-sm items-end">
              <div class="super-box">
                <OSvg svg="new-mail" class="fill-neutral-600" />
              </div>
              <div class="pl-rem flex flex-col">
                <p class="font-display font-bold" v-text="getTranslation('Shipping')" />
                <p class="font-body flex flex-row items-center">
                  <OSvg svg="labelsvg" class="fill-neutral-600 mr-1" />
                  <span class="text-neutral-600" v-text="getTranslation('ShippedWithin')" />
                </p>
              </div>
              <div class="ml-auto flex flex-col text-right">
                <p class="font-display font-extrabold text-green-400" v-text="formattedFreePrice" />
              </div>
            </div>
            <hr class="mt-5 mb-3 border-neutral-200">
            <div class="flex justify-between">
              <span class="font-display font-extrabold text-sm uppercase" v-text="$t('SignUp.StepFive.Total')" />
              <div class="flex flex-row items-center">
                <p class="font-display font-normal line-through pr-3" v-text="(isWomenOnePager || showTwoForOneCampaign) ? formattedTwoForOnePrice : formattedPrice" />
                <span class="font-display font-extrabold text-sm uppercase text-green-400" v-text="getTranslation('Free')" />
              </div>
            </div>
          </section>
          <section v-if="!isSpecialDesign" class="mt-10">
            <div
              data-qa="signup-information"
              class="bg-gray-50 px-4 py-5 lg:hidden"
            >
              <client-only>
                <div v-for="(usp, index) in usps" :key="index" class="flex mb-3 items-center">
                  <OSvg class="fill-green-400 w-4 mr-2 mt-1 flex-shrink-0" svg="checkmark" />
                  <span class="text-xs font-display font-bold text-gray-600" v-text="usp" />
                </div>
              </client-only>
              <div v-if="isWomenOnePager">
                <NewButton
                  icon-right="new-chevron-right"
                  icon-classes="w-6"
                  variant="plane"
                  class="text-gray-600"
                  @click="$refs.womenHowItWorksModal.toggleActivation()"
                >
                  <span class="font-bold text-sm">
                    {{ $t('LandingsPage.Women.Every3MonthsFreeTop.Title', variables) }}
                  </span>
                </NewButton>
              </div>
            </div>
          </section>
          <section v-else class="px-4 lg:px-0 pb-4">
            <hr class="mt-6 mb-3 border-neutral-200">
            <div class="mt-7 special-design-info lg:p-10 py-12 px-7 lg:flex" :style="{ backgroundColor: designColors.primaryColor }">
              <div class="lg:pr-10">
                <p class="o-heading-1 md:o-heading-2 text-white text-center mb-rem lg:text-left" v-text="$t(`SpecialDesigns.${fixedDesignSlug}.Signup.Title`)" />
                <p class="ota-p14 text-sm text-white text-center mb-4 lg:text-left lg:mb-0" v-text="$t(`SpecialDesigns.${fixedDesignSlug}.Signup.Description`)" />
              </div>
              <div class="lg:flex lg:justify-center lg:items-center">
                <div class="flex justify-center">
                  <OImage v-bind="specialDesignLogoImage" img-class="pointer-events-none special-design-logo" />
                </div>
              </div>
            </div>
          </section>
          <section ref="size" class="text-gray-600 mt-6 px-4 lg:px-0 overflow-hidden">
            <div class="lg:flex">
              <div v-if="!isWomenOnePager" class="pick-size-texts relative">
                <h1 class="o-heading-1 lg:o-heading-2 text-left" v-text="$t('HomePage.SelectSize', variables)" />
                <p class="o-body text-left" v-text="$t('SignUp.SizeTip', variables)" />
                <div class="absolute top-0 product-image-overlay lg:hidden">
                  <OImage
                    v-bind="productImage"
                    img-class="w-full h-full object-cover pointer-events-none"
                    :alt="$t('Accessibilty.AltTags.WomenProductImage')"
                  />
                </div>
              </div>
              <div v-else-if="isWomenOnePager" :class="['women-pick-size-texts relative', readMore.bralette ? 'pb-5 lg:pb-7' : '']">
                <h1 class="o-heading-1 lg:o-heading-2 text-left mb-4" v-text="getTranslation('Women.ChooseSizes')" />
                <div class="flex">
                  <div class="pt-5">
                    <p class="o-heading-3 text-left" v-text="$t('SignUp.Women.StepOne.Top.Title')" />
                    <p class="ota-p14 text-left">
                      <span class="text-gray-500 md:hidden" v-text="readMore.bralette ? $t('SignUp.Women.StepOne.Top.Description') : truncateText($t('SignUp.Women.StepOne.Top.Description'))" />
                      <span class="text-gray-500 hidden md:inline" v-text="readMore.bralette ? $t('SignUp.Women.StepOne.Top.Description') : truncateText($t('SignUp.Women.StepOne.Top.Description'), 23)" />
                      <button class="font-bold text-neutral-800 inline-flex items-center gap-1 cursor-pointer" @click="toggleReadMore('bralette')">
                        <span v-text="readMore.bralette ? getTranslation('Women.Readless') : getTranslation('Women.ReadMore')" />
                        <OSvg svg="new-chevron-down" :class="['w-2 mt-1 fill-neutral-800 transform transition-transform duration-300', readMore.bralette ? 'rotate-180' : '']" />
                      </button>
                    </p>
                  </div>
                  <div class="women-pick-size-texts-image-container">
                    <OImage
                      v-bind="productImage"
                      img-class="w-full h-full object-contain pointer-events-none"
                      :alt="$t('Accessibilty.AltTags.WomenProductImage')"
                    />
                  </div>
                </div>
              </div>
              <div class="hidden lg:block lg:ml-auto lg:mt-2">
                <TabSlider
                  v-if="showTabSlider"
                  class="mb-4 tabslider-size"
                  :class="{ 'opacity-0 pointer-events-none': isSpecialDesign }"
                  :notifications="0"
                  :button-one-text="$t('SizeChart.Table.Titles.Men')"
                  :button-two-text="$t('SizeChart.Table.Titles.Boys')"
                  :start-mode="tabSliderMode"
                  @switch="tabSliderMode = $event.mode"
                />
              </div>
            </div>
            <div class="my-5 lg:mt-2">
              <TabSlider
                v-if="showTabSlider"
                class="mb-4 tabslider-size lg:hidden"
                :class="{ 'opacity-0 pointer-events-none': isSpecialDesign }"
                :notifications="0"
                :button-one-text="$t('SizeChart.Table.Titles.Men')"
                :button-two-text="$t('SizeChart.Table.Titles.Boys')"
                :start-mode="tabSliderMode"
                @switch="tabSliderMode = $event.mode"
              />
              <ButtonPicker ref="buttonPicker" class="mt-0" v-bind="buttonPickerProps" @click="onSizeSelect" />
              <div class="flex justify-between mt-3 lg:mt-1">
                <p class="flex items-center mt-2 gap-2">
                  <OSvg svg="new-danger" class="fill-orange-600" width="20" />
                  <span class="font-display font-extrabold orange-badge" v-text="countdownIsExpired ? getTranslation('ReserveExpired') : $t('SignUp.OnePage.HurryFewLeft', variables)" />
                </p>
                <div>
                  <NewButton
                    icon-left="measure"
                    icon-classes="w-6"
                    variant="plane"
                    class="text-gray-600 size-button"
                    @click="onSizeChartButtonClick"
                  >
                    {{ $t('SignUp.SizeHelp') }}
                  </NewButton>
                </div>
              </div>
            </div>
          </section>
          <template v-if="isWomenOnePager">
            <div :class="['women-pick-size-texts px-4 lg:px-0', readMore.hipster ? 'pb-5 lg:pb-7' : '']">
              <div class="flex">
                <div class="pt-5">
                  <p class="o-heading-3 text-left" v-text="$t('SignUp.Women.StepOne.Hipster.Title')" />
                  <p class="ota-p14 text-left">
                    <span class="text-gray-500 md:hidden" v-text="readMore.hipster ? $t('SignUp.Women.StepOne.Hipster.Description') : truncateText($t('SignUp.Women.StepOne.Hipster.Description'))" />
                    <span class="text-gray-500 hidden md:inline" v-text="readMore.hipster ? $t('SignUp.Women.StepOne.Hipster.Description') : truncateText($t('SignUp.Women.StepOne.Hipster.Description'), 23)" />
                    <button class="font-bold text-neutral-800 inline-flex items-center gap-1 cursor-pointer" @click="toggleReadMore('hipster')">
                      <span v-text="readMore.hipster ? getTranslation('Women.Readless') : getTranslation('Women.ReadMore')" />
                      <OSvg svg="new-chevron-down" :class="['w-2 mt-1 fill-neutral-800 transform transition-transform duration-300', readMore.hipster ? 'rotate-180' : '']" />
                    </button>
                  </p>
                </div>
                <div class="women-pick-size-texts-image-container">
                  <OImage v-bind="secondaryProductImage" img-class="w-full h-full object-contain pointer-events-none" />
                </div>
              </div>
            </div>
            <div ref="secondarySize" class="my-5 px-4 lg:px-0">
              <ButtonPicker ref="secondaryButtonPicker" class="mt-0" v-bind="secondaryButtonPickerProps" @click="onSecondarySizeSelect" />
              <div class="flex justify-between mt-3 lg:mt-1">
                <p class="flex items-center mt-2 gap-2">
                  <OSvg svg="new-danger" class="fill-orange-600" width="20" />
                  <span class="font-display font-extrabold  orange-badge" v-text="countdownIsExpired ? getTranslation('ReserveExpired') : $t('SignUp.OnePage.HurryFewLeft', variables)" />
                </p>
                <div>
                  <NewButton
                    icon-left="measure"
                    icon-classes="w-6"
                    variant="plane"
                    class="text-gray-600 size-button"
                    @click="hipsterSizeChartClick"
                  >
                    {{ $t('SignUp.SizeHelp') }}
                  </NewButton>
                </div>
              </div>
            </div>
          </template>
          <section v-if="isOnePagerWithDesignChoice || isWomenOnePagerWithDesignChoice" ref="design" class="px-4 lg:px-0">
            <hr class="my-7">
            <h2 class="o-heading-1 lg:o-heading-2 text-left mb-2" v-text="isWomenOnePagerWithDesignChoice ? $t('SignUp.Women.StepTwo.Title', variables) : getTranslation('ChooseDesignTitle')" />
            <p class="ota-p14 text-left text-gray-500 mb-3" v-html="isWomenOnePagerWithDesignChoice ? $t('SignUp.Women.StepTwo.Description', variables) : getTranslation('ChooseDesignDescription')" />
            <TabSlider
              v-if="!isBoysOriginals && sizeReference && !isWomenOnePagerWithDesignChoice"
              class="mb-4"
              :notifications="0"
              :button-one-text="getTranslation('WithPrint')"
              :button-two-text="getTranslation('WithoutPrint')"
              :start-mode="orientationSliderMode"
              @switch="orientationSliderMode = $event.mode"
            />
          </section>
        </div>
        <section class="design-picker-container relative">
          <DesignPicker
            v-if="(isOnePagerWithDesignChoice || isWomenOnePagerWithDesignChoice) && (sizeReference || dummySizeReference)"
            ref="designPicker"
            :key="`${form.membershipType}-${sizeReference || dummySizeReference}-1`"
            custom-select-class="design-picker-primary"
            v-bind="designPickerProps"
            @select="onDesignClick"
            @disabledClick="onDisabledDesignPickerClick"
          />
          <DesignPicker
            v-if="isWomenOnePagerWithDesignChoice && (secondarySizeReference || secondaryDummySizeReference)"
            ref="secondaryDesignPicker"
            :key="`${form.membershipType}-${secondarySizeReference || secondaryDummySizeReference}-2`"
            class="mt-4"
            custom-select-class="design-picker-secondary"
            :designs="secondaryDesignsToPick"
            :selected-design-reference="secondaryDesignSlug"
            :image-postfix="boxershortPostfix"
            :product-group="productGroup"
            :product-group-reference="Orientations.womenhipster"
            :disable-slider="disableDesignPicker"
            @select="onSecondaryDesignClick"
            @disabledClick="onDisabledDesignPickerClick"
          />

          <transition name="fade">
            <div v-if="disableDesignPicker" class="design-picker-container-cloak" />
          </transition>
        </section>
        <div class="lg:px-10">
          <div
            v-if="showSpecialDesignSizeSoldOutNotification"
            class="px-4 pt-5 lg:px-0"
          >
            <SimpleNotification
              svg="info"
              :title="getTranslation('SizeSoldOutNotification.Title')"
              :description="getTranslation('SizeSoldOutNotification.Description')"
            />
          </div>
          <section ref="account" class="px-4 lg:px-0">
            <hr class="my-7">
            <h3 class="o-heading-1 lg:o-heading-2 text-left mb-2" v-text="isWomenOnePager ? getTranslation('Women.YourDetails') : getTranslation('AccountTitle')" />
            <p class="ota-p14 text-left text-gray-500" v-html="getTranslation('AccountDescription')" />
            <div class="mt-5">
              <CreateAccountForm
                ref="createAccountFormOne"
                :first-name="form.firstName"
                :last-name="form.lastName"
                :errors="formatErrors(errors)"
                :email="form.email"
                :password="form.password"
                :country="country"
                no-first-name-lastname
                @submit="onSubmit"
              />
            </div>
          </section>
          <section ref="address">
            <div class="px-4 lg:px-0">
              <hr class="my-7">
              <h4 class="o-heading-1 lg:o-heading-2 text-left mb-2" v-text="getTranslation('Address')" />
              <p class="ota-p14 text-left text-gray-500 mb-5" v-html="isWomenOnePager ? $t('SignUp.Women.StepFour.Title', { ...variables }) : getTranslation('AddressDescription')" />
              <CreateAccountForm
                ref="createAccountFormTwo"
                :first-name="form.firstName"
                :last-name="form.lastName"
                :errors="formatErrors(errors)"
                :email="form.email"
                :password="form.password"
                :country="country"
                minimal
                @submit="onSubmit"
              />
              <OSelect
                :label="$t('Navbar.Country')"
                :value="countrySettings.current"
                :options="countrySettings.options"
                class="my-2"
                svg-classes="rounded"
                :clearable="false"
                @input="changeCountry($event.value)"
              />
              <client-only>
                <AddressForm
                  ref="addressForm"
                  class="mb-3 address-form"
                  :country-code="country"
                  :errors="oldErrors"
                  success-button-text="SignUp.Proceed"
                  button-size="md"
                  hide-country
                  hide-submit
                  :submit-button-classes="['hidden', 'lg:flex', 'lg:justify-start']"
                  v-bind="{ ...ExtendedAddressFormDataProps, ...loqateAddressFormProps }"
                  @input="findAddressSuggestions({ Text: $event, Countries: country })"
                  @select="pickAddressSuggestion($event, setAddressSuggestion)"
                  @clear="setSuggestions()"
                  @fill-address-manually="fillAddressManually = true"
                  @change="onAddressChange"
                  @focus="focusLoqate"
                  @submit="value => checkFormAddress({ ...value, callback: onSubmit })"
                />
              </client-only>
              <div
                v-if="showTwoForOneCampaign"
                class="bg-gray-50 p-5 mb-7 text-neutral-800 rounded-md lg:mb-14"
              >
                <p class="ota-p12 font-body font-normal" v-text="getTranslation('Campaign.TwoForOne.Explanation')" />
              </div>
              <hr class="my-7">
            </div>
          </section>
          <section ref="payment">
            <div class="px-4 pb-5 lg:px-0">
              <h5 class="o-heading-1 lg:o-heading-2 text-left mb-2" v-text="getTranslation('Payment')" />
              <p class="ota-p14 text-left text-gray-500 mb-rem" v-html="$t('SignUp.StepFive.VerificationPaymentBody', variables)" />
              <p class="flex items-center justify-end mt-2 gap-2 mb-3">
                <OSvg svg="secure-payment-lock" class="fill-green-400" />
                <span class="text-green-400 font-body font-bold text-xs" v-text="getTranslation('SafePayment')" />
              </p>
              <PaymentForm
                :key="country"
                ref="paymentFormComponent"
                v-bind="extraPaymentFormProps"
                :user-country="country"
                :amount="selectedMethod ? selectedMethod.verificationAmount : 1.00"
                :email="form.email"
                :ip-address="ipAddress"
                :surname="form.lastName"
                :given-name="form.firstName"
                billing-agreement-description="ON THAT ASS Subscription"
                hide-submit
                :optin-label="$t('SignUp.StepFive.OptIn')"
                :consent-error-message="getTranslation('ConsentRequired')"
                @method="selectedMethod = $event"
                @issuer="selectedIssuer = $event"
                @payment-nonce="onReceivePaymentNonce($event)"
                @billing-metadata="billingMetadata = $event"
                @external-identifier="externalIdentifier = $event"
                @deviceData="deviceData = $event"
                @consentChange="onConsentChange"
                @optInChange="onOptInChange"
              />
            </div>
          </section>
          <div class="text-center px-4 lg:px-0 mb-5">
            <OButton
              v-bind="buttonProps"
              class="w-full"
              :attribute="{ name: 'data-qa', value: 'signup-confirm-payment' }"
              @click="onSubmit"
            >
              {{ $t('SignUp.StepFive.CompleteWithConsent') }}
            </OButton>
          </div>
          <client-only>
            <PromoCode
              class="mb-7"
              :promotion-code="form.promotionCode"
              @delete="deletePromoCode"
              @open="openModal"
            />
          </client-only>
          <article class="custom-padding">
            <client-only>
              <ul class="list-disc list-outside">
                <li class="mb-rem">
                  <i18n :path="firstCtaLineItemText" class="text-gray-600 o-caption">
                    <template #0>
                      <a
                        class="underline cursor-pointer"
                        @click="termsAndConditions"
                        v-text="$t('SignUp.OnePage.LinkWords.TermsAndConditions')"
                      />
                    </template>
                    <template #1>
                      <a
                        class="underline cursor-pointer"
                        @click="termsOfUse"
                        v-text="$t('SignUp.StepFive.TermsOfUse')"
                      />
                    </template>
                    <template #2>
                      <a
                        class="underline cursor-pointer"
                        @click="privacyStatement"
                        v-text="$t('SignUp.OnePage.LinkWords.PrivacyStatement')"
                      />
                    </template>
                    <template #3>
                      <a
                        class="underline cursor-pointer"
                        @click="rightOfWithdrawal"
                        v-text="$t('RightOfWithdrawal.General.Title')"
                      />
                    </template>
                    <template #TermsAndConditions>
                      <a
                        class="underline cursor-pointer"
                        @click="termsAndConditions"
                        v-text="$t('SignUp.Women.StepFive.TermsAndConditions')"
                      />
                    </template>
                    <template #PrivacyStatement>
                      <a
                        class="underline cursor-pointer"
                        @click="privacyStatement"
                        v-text="$t('SignUp.Women.StepFive.PrivacyStatement')"
                      />
                    </template>
                    <template #RightOfWithdrawal>
                      <a
                        class="underline cursor-pointer"
                        @click="rightOfWithdrawal"
                        v-text="$t('SignUp.OnePage.LinkWords.RightOfWithdrawal')"
                      />
                    </template>
                  </i18n>
                </li>
                <li class="mb-rem">
                  <span class="text-gray-600 o-caption" v-text="isWomenOnePager ? $t('SignUp.Women.StepFive.PriceAfterTrial', { ...variables }) : $t('SignUp.StepFive.PaymentAfterTrial', { ...variables })" />
                </li>
                <li class="mb-rem">
                  <span class="text-gray-600 o-caption" v-text="lastBulletPoint" />
                </li>
              </ul>
            </client-only>
          </article>
          <div class="px-4 lg:px-1">
            <client-only>
              <OptIn
                class="custom-opt-in"
                :value="form.optIn"
                :label="optOutLabel"
                @input="setSignupFormField({ key: 'optIn', value: $event })"
              />
            </client-only>
          </div>
          <hr class="my-7">
          <div class="px-4">
            <div
              data-qa="signup-step-5-information-2"
              class="bg-gray-50 p-5 mb-7 rounded-md lg:mb-14"
            >
              <p class="text-sm font-extrabold font-display mb-rem" v-text="$t('SignUp.StepFive.HowDoesTheTrialWork', variables)" />
              <p class="ota-p12 font-body font-normal" v-text="isWomenOnePager ? $t('SignUp.Women.StepFive.HowDoesTheTrialWorkDescription', variables) : $t('SignUp.StepFive.HowDoesTheTrialWorkDescription', variables)" />
            </div>
          </div>
          <div class="px-3 pb-24 lg:px-0">
            <Faq
              data-qa="signup-faq"
              :items="faqItems"
            />
          </div>
        </div>
        <template v-slot:secondary-content>
          <div class="radius-corners-2 h-full relative bg-gray-100">
            <div
              data-qa="signup-information"
              class="bg-gray-100 px-10 pb-5 pt-14"
            >
              <client-only>
                <div v-for="(usp, index) in usps" :key="index" class="flex mb-3 items-center">
                  <OSvg class="fill-green-400 w-4 mr-2 mt-1 flex-shrink-0" svg="checkmark" />
                  <span class="text-xs font-display font-bold text-gray-600" v-text="usp" />
                </div>
              </client-only>
              <div v-if="isWomenOnePager">
                <NewButton
                  icon-right="new-chevron-right"
                  icon-classes="w-6"
                  variant="plane"
                  class="text-gray-600"
                  @click="$refs.womenHowItWorksModal.toggleActivation()"
                >
                  <span class="font-bold text-sm">
                    {{ $t('LandingsPage.Women.Every3MonthsFreeTop.Title', variables) }}
                  </span>
                </NewButton>
              </div>
            </div>
            <div class="sticky top-0">
              <OImage
                img-class="object-cover model-image pointer-events-none"
                size="cover"
                :alt="$t('Accessibilty.AltTags.CampaignPhoto')"
                v-bind="modelImage"
              />
            </div>
          </div>
        </template>
      </SignUpLayoutBox>
      <StickyATC
        v-if="!hideStickyATC"
        class="lg:hidden sticky shadow-md"
        :text="stickyATCText"
        :button-props="{
          attribute: { name: 'data-qa', value: 'signup-confirm-orientation-mobile' },
          variant: 'dark-green',
          disabled: submitLoading
        }"
        @click="onSubmit"
      />
    </div>
    <div class="pt-24 md:pb-14">
      <PolicyLinks />
    </div>

    <TermsofUseModal
      ref="TermsofUseModal"
    />
    <RightOfWithdrawalModal
      ref="RightOfWithdrawalModal"
    />
    <PrivacyStatementModal
      ref="PrivacyStatementModal"
      :locale="locale"
    />
    <PromotionCodeModal
      ref="promotionCodeModal"
      :loading="couponCodeLoading"
      :value="form.promotionCode"
      :error="couponCodeError"
      @submit="trySetPromotionCode"
    />
    <WomenHowItWorksModal
      v-if="isWomenOnePager"
      ref="womenHowItWorksModal"
      :description="$t('LandingsPage.Women.Every3MonthsFreeTop.Description', variables)"
      :how-it-works-slides="womenHowItWorksSlides"
      hide-atc
    />
    <SizeChartModal ref="sizeChartModal" />
    <WomenSizeChartModal
      ref="WomenSizeChartModal"
      :country="country"
    />
    <SignupOutOfStockModal
      ref="SignupOutOfStockModal"
      v-bind="SignupOutOfStockModalProps"
    />
    <div v-if="submitLoading" class="fixed top-0 left-0 right-0 bottom-0 w-full h-full z-70">
      <div v-loading="submitLoading" class="flex items-center justify-center h-full z-70" />
    </div>
    <OnePagerStickyReceipt
      class="z-30"
      :filler-width="fillerWidth"
      :is-visible="isStickyATCVisible"
      :products="stickyReceiptProducts"
      @click="onReceiptClick"
    />
  </div>
</template>

<script>
import TabSlider, { modes } from '@/components/TabSlider/TabSlider'
import { MembershipTypes } from '@/enums/member'
import { BoysPrices, MenPrices, NewOrientations, Orientations, SocksPrices, UndershirtsPrices, WomenPrices } from '@/enums/products'
import { addLocalCurrency, capitalize, getImagePaths, serializeParameters, stripLanguageRegex } from '@/utils/general'
import OImage from '@/components/OImage'
import DesignPicker from '@/components/DesignPicker'
import OSvg from '@/components/OSvg'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import {
  SIGNUP_CREATE_PROSPECT,
  SIGNUP_CREATE_VERIFICATION_PAYMENT,
  SIGNUP_UPDATE_MEMBERSHIP_TYPE,
  SIGNUP_UPDATE_PROSPECT_ACCOUNT,
  SIGNUP_UPDATE_PROSPECT_ADDRESS,
  SIGNUP_USE_COUPON_CODE
} from '@/utils/store/actionTypes'
import WomenSizeChartModal from '@/components/Women/SizeChartModal'
import WomenHowItWorksModal from '@/components/Women/HowItWorksModal'
import { groupMembershipTypeAvailableDesigns, groupMembershipTypesSizesForDesign, getMembershipTypeDesignWithMostStockInSpecificSize, getMembershipTypeIsDesignAvailableInSpecificSize, givenProductGroupReturnFirstAvailableSizeReference } from '@/utils/products'
import SignUpLayoutBox from '@/components/SignUpLayoutBox'
import { CountrySelectOptions, Currencies, DaysToSubtractFromDeliveryDate } from '@/enums/general'
import Faq from '@/components/Faq'
import StickyATC from '@/components/StickyATC'
import OSelect from '@/components/OSelect'
import { SET_ADDRESS_CONFIRMED, SET_ADDRESS_FORM_FIELD, SET_FORM_FIELD, SET_COUNTRY } from '@/utils/store/mutationTypes'
import PolicyLinks from '@/components/PolicyLinks'
import RightOfWithdrawalModal from '@/components/Modals/RightOfWithdrawalModal'
import PromoCode from '@/components/PromoCode'
import CountdownTimer from '@/components/CountdownTimer'
import PrivacyStatementModal from '@/components/Modals/PrivacyStatementModal'
import PromotionCodeModal from '@/components/Modals/PromotionCodeModal'
import { idPrefixes, OnePagerTypes, PromoCodesByVendor } from '@/enums/signup'
import ErrorsMixin from '@/mixins/errors'
import CreateAccountForm from '@/components/Forms/CreateAccountForm'
import AddressForm from '@/components/Forms/AddressForm'
import addressCheck from '@/mixins/addressCheck'
import loqateMixin from '@/mixins/loqate'
import PaymentForm from '@/components/PaymentForm'
import { PersistentStorageKeys } from '@/enums/app'
import { braintreeApplePay, braintreeCreditCard, braintreeGooglePay, paypal } from '@/enums/payments'
import { CookieDuration, EverflowClientAffiliateIDCookie, EverflowClientCookie, EverflowClientSourceIDCookie, EverflowClientSubIDCookie, OTACountdownCookie, PromotionCodeCookie, SnapchatClickIdCookie, UTMCampaignCookie, UTMMediumCookie } from '@/enums/gtm'
import { pushToDataLayer } from '@/utils/gtm'
import { getCookieDomain } from '@/utils/cookie'
import OButton from '@/components/OButton'
import ButtonPicker from '@/components/ButtonPicker'
import OnePagerStickyReceipt from '@/components/OnePagerStickyReceipt'
import NewButton from '@/components/NewButton'
import SimpleNotification from '@/components/Notifications/SimpleNotification'
import { getMembershipTypeUrl, getWomenProductGroupSizeDesigns } from '@/utils/prospect'
import SizeChartModal from '@/components/Modals/SizeChart'
import { IS_TWO_FOR_ONE_CAMPAIGN } from '@/utils/store/getterTypes'
import { CCOUNTRY } from '@/utils/cookie/cookieTypes'
import SignupOutOfStockModal from '@/components/SignupOutOfStockModal'
import cookieConfig from '@/config/cookie'
import { datadogRum } from '@datadog/browser-rum'
import textVariablesMixin from '@/mixins/textVariables'
import TermsofUseModal from '@/components/Modals/TermsofUseModal.vue'
import OptIn from '@/components/OptIn'

const COUNTDOWN_TIME = 15 * 60 // 15 minutes

export default {
  name: 'OnePageSignup',
  components: {
    TermsofUseModal,
    OImage,
    SignUpLayoutBox,
    OSvg,
    OnePagerStickyReceipt,
    StickyATC,
    OSelect,
    PolicyLinks,
    Faq,
    RightOfWithdrawalModal,
    PromoCode,
    PrivacyStatementModal,
    PromotionCodeModal,
    CreateAccountForm,
    AddressForm,
    PaymentForm,
    OButton,
    CountdownTimer,
    TabSlider,
    ButtonPicker,
    NewButton,
    SizeChartModal,
    DesignPicker,
    WomenSizeChartModal,
    WomenHowItWorksModal,
    SimpleNotification,
    SignupOutOfStockModal,
    OptIn
  },
  mixins: [ErrorsMixin, addressCheck, loqateMixin, textVariablesMixin],
  props: {
    onePagerType: {
      type: String,
      default: OnePagerTypes.minimal
    },
    designResponse: {
      type: Object,
      default: () => ({})
    },
    secondaryDesignResponse: {
      type: Object,
      default: () => ({})
    },
    membershipTypes: {
      type: Array,
      default: () => []
    },
    orientation: {
      type: String,
      default: ''
    },
    productGroup: {
      type: String,
      default: ''
    },
    fixedDesignSlug: {
      type: String,
      default: ''
    },
    secondaryFixedDesignSlug: {
      type: String,
      default: ''
    },
    designSlug: {
      type: String,
      default: ''
    },
    secondaryDesignSlug: {
      type: String,
      default: ''
    },
    sizeReference: {
      type: String,
      default: ''
    },
    secondarySizeReference: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timeRemaining: this.$cookies.get(OTACountdownCookie) || COUNTDOWN_TIME,
      countdownInterval: null,

      couponCodeLoading: false,
      errors: {},
      oldErrors: {},

      selectedMethod: null,
      selectedIssuer: null,
      paymentMethodNonce: null,
      deviceData: null,
      submitLoading: false,
      areAllFormsValidInterval: null,
      areAllFormsValid: false,
      tabSliderMode: modes.gifts,
      orientationSliderMode: modes.gifts,
      alwaysShowAddressForm: false,
      externalIdentifier: null,
      billingMetadata: null,
      isStickyATCVisible: false,
      readMore: {}
    }
  },
  computed: {
    lastBulletPoint () {
      return this.$t('SignUp.Women.StepFive.OptOutVariant', { ...this.variables })
    },
    optOutLabel () {
      return this.$t('SignUp.StepFive.OptOut', { ...this.variables })
    },
    currentDesignGroup () {
      if (!this.designSlug) {
        return null
      }

      const design = this.designsToPick.find(design => design.reference === this.designSlug)

      if (!design) {
        return null
      }

      return design.designGroup
    },
    secondaryCurrentDesignGroup () {
      if (!this.secondaryDesignSlug) {
        return null
      }

      const design = this.secondaryDesignsToPick.find(design => design.reference === this.secondaryDesignSlug)

      if (!design) {
        return null
      }

      return design.designGroup
    },
    optinLabel () {
      return this.$t('SignUp.StepFive.OptIn')
    },
    extraPaymentFormProps () {
      const props = {
        consentValue: this.form.consent,
        showConsent: true
      }

      return props
    },
    optinEnhancedValue () {
      return !this.form.optIn
    },
    firstCtaLineItemText () {
      return 'SignUp.StepFive.ConsentABTest'
    },
    couponCodeError () {
      return this.couponCodeErrors?.couponCode?.populatedError
    },
    disableDesignPicker () {
      if (this.isWomenOnePager) {
        return !this.sizeReference || !this.secondarySizeReference
      }

      return !this.sizeReference
    },
    isCurrentDesignTheFixedDesign () {
      return this.designSlug === this.fixedDesignSlug
    },
    isSecondaryCurrentDesignTheFixedDesign () {
      return this.secondaryDesignSlug === this.secondaryFixedDesignSlug
    },
    showSpecialDesignSizeSoldOutNotification () {
      return this.isSpecialDesign && this.fixedDesignSlug !== this.designSlug
    },
    SignupOutOfStockModalProps () {
      return {
        title: this.getTranslation('OutOfStockModal.Title'),
        description: this.getTranslation('OutOfStockModal.Description'),
        secondaryTitle: this.$t('SpecialDesigns.general.EmailAddressAlreadyKnown', this.variables),
        secondaryDescription: this.$t('SpecialDesigns.general.EmailAddressAlreadyKnownDescription', this.variables),
        successMessage: this.isSpecialDesign ? this.$t('SpecialDesigns.general.EmailAddressAlreadyKnownSubmittedText', this.variables) : this.getTranslation('OutOfStockModal.Success'),
        cta: this.isSpecialDesign ? this.$t('SpecialDesigns.general.EmailAddressAlreadyKnownCTA', this.variables) : this.getTranslation('OutOfStockModal.CTA'),
        submittedCta: this.isSpecialDesign ? this.$t('SpecialDesigns.general.EmailAddressAlreadyKnownSubmittedCTA', this.variables) : this.getTranslation('OutOfStockModal.SubmittedCTA'),
        country: this.country,
        design: this.fixedDesignSlug
      }
    },
    designPickerProps () {
      const productGroupReference = this.isWomenOnePager ? Orientations.womenbralette : this.productGroup

      return {
        designs: this.designsToPick,
        selectedDesignReference: this.designSlug,
        imagePostfix: this.boxershortPostfix,
        productGroup: this.productGroup,
        productGroupReference,
        disableSlider: this.disableDesignPicker,
        showIsFeatured: this.isOnePagerWithDesignChoice
      }
    },
    Orientations () {
      return Orientations
    },
    isSpecialDesign () {
      return this.specialDesigns.some(design => design.slug === this.fixedDesignSlug)
    },
    sizeValue () {
      if (!this.sizeReference) {
        return undefined
      }

      if (this.isWomenOnePager) {
        return { value: this.form[Orientations.womenbralette].size.reference, label: this.form[Orientations.womenbralette].size.label }
      }

      return { value: this.form.size.reference, label: this.form.size.label }
    },
    waitDaysValue () {
      return null
    },
    isV2ThankYouPageVariant () {
      return false
    },
    signupThankYouPageVariantValue () {
      if (this.isV2ThankYouPageVariant) {
        if (this.isWomenOnePager) {
          return 'variant-2'
        }

        return 'variant-1'
      }

      return 'control'
    },
    dummySizeReference () {
      if (this.isWomenOnePager) {
        return givenProductGroupReturnFirstAvailableSizeReference(this.membershipTypes, Orientations.womenbralette)
      }

      return givenProductGroupReturnFirstAvailableSizeReference(this.membershipTypes, this.productGroup)
    },
    secondaryDummySizeReference () {
      return givenProductGroupReturnFirstAvailableSizeReference(this.membershipTypes, Orientations.womenhipster)
    },
    designsToPick () {
      if (this.isWomenOnePager) {
        return groupMembershipTypeAvailableDesigns(this.membershipTypes, this.sizeReference || this.dummySizeReference, Orientations.womenbralette)
      }

      return groupMembershipTypeAvailableDesigns(this.membershipTypes, this.sizeReference || this.dummySizeReference, this.productGroup)
    },
    secondaryDesignsToPick () {
      return this.getDesignsToPick({ productGroup: Orientations.womenhipster, sizeReference: this.secondarySizeReference || this.secondaryDummySizeReference })
    },
    isBoysOriginals () {
      return this.form.membershipType === MembershipTypes.boysOriginals
    },
    stickyReceiptProducts () {
      let products = [
        {
          image: this.productImage,
          name: this.variables.product,
          price: this.formattedPrice,
          text: this.getTranslation('Free')
        }
      ]

      if (this.isWomenOnePager) {
        products = [
          {
            image: this.productImage,
            name: `${this.$t('Sizechart.TopSizeChart.Title')} + ${capitalize(this.variables.product)}`,
            price: this.formattedTwoForOnePrice,
            text: this.getTranslation('Free'),
            comboImage: this.secondaryProductImage
          }
        ]
      }

      if (this.showTwoForOneCampaign) {
        products.unshift({
          image: this.mysteryImage,
          name: this.variables.product,
          price: this.formattedPrice,
          text: this.getTranslation('Free'),
          dealText: this.getTranslation('Campaign.TwoForOne.Label')
        })
      }

      return products
    },
    productImageText () {
      if (this.showTwoForOneCampaign) {
        return this.getTranslation('Campaign.TwoForOne.ProductImageText')
      }

      return this.$t('Account.Home.YourGifts.Free', this.variables)
    },
    fillerWidth () {
      return (this.timeRemaining / COUNTDOWN_TIME) * 100
    },
    countdownIsExpired () {
      return this.timeRemaining <= 0
    },
    buttonPickerProps () {
      return {
        errorMessage: this.$t('SignUp.PickSize'),
        activeValue: this.sizeReference,
        optionGroups: [
          {
            options: this.sizeOptions,
            dataQa: 'signup-step-1-size'
          }
        ]
      }
    },
    secondaryButtonPickerProps () {
      return {
        errorMessage: this.$t('SignUp.PickSize'),
        activeValue: this.secondarySizeReference,
        optionGroups: [
          {
            options: this.getSizeOptions({ productGroup: Orientations.womenhipster, membershipTypes: this.membershipTypes, designSlug: this.secondaryDesignSlug }),
            dataQa: 'signup-step-2-size'
          }
        ]
      }
    },
    hideStickyATC () {
      if (
        this.selectedMethod?.value === braintreeCreditCard.value ||
        this.selectedMethod?.value === paypal.value ||
        this.selectedMethod?.value === braintreeApplePay.value ||
        this.selectedMethod?.value === braintreeGooglePay.value
      ) {
        return this.buttonProps.disabled
      }

      return false
    },
    buttonProps () {
      const disabled = !this.selectedMethod ||
        (this.selectedMethod.value === paypal.value && !this.paymentMethodNonce) ||
        (this.selectedMethod.value === braintreeCreditCard.value && !this.paymentMethodNonce) ||
        (this.selectedMethod.value === braintreeApplePay.value && !this.paymentMethodNonce) ||
        (this.selectedMethod.value === braintreeGooglePay.value && !this.paymentMethodNonce) ||
        this.submitLoading

      return {
        variant: disabled ? 'dark' : 'dark-green',
        disabled
      }
    },
    countrySettings () {
      const options = CountrySelectOptions.map(option => ({ ...option, label: this.$t(option.label) }))
      return { current: options.find(option => option.value === this.country), options }
    },
    womenHowItWorksSlides () {
      const path = 'LandingsPage.Women.Every3MonthsFreeTop.Items'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, i) => ({
        svg: this.$t(`${path}[${i}].Svg`),
        title: this.$t(`${path}[${i}].Title`, this.variables),
        description: this.$t(`${path}[${i}].Description`, this.variables)
      }))
    },
    usps () {
      const path = this.isWomenOnePager ? 'SignUp.Women.StepThree.USPS' : 'SignUp.StepThree.USPS'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      const enrichedItems = items.map((_, index) => this.$t(`${path}[${index}]`, this.variables))

      if (this.showTwoForOneCampaign) {
        const newUsp = this.getTranslation('Campaign.TwoForOne.NewUsp')

        enrichedItems[0] = newUsp
      }

      return enrichedItems
    },
    ExtendedAddressFormDataProps () {
      return {
        ...this.addressFormDataProps,
        alwaysShowAddressForm: this.alwaysShowAddressForm
      }
    },
    faqItems () {
      const path = this.isWomenOnePager ? 'SignUp.Women.StepFive.FAQ' : 'SignUp.StepThree.FaqItems'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      const enrichedItems = items.map((_, i) => ({
        title: this.$t(`${path}[${i}].title`, this.variables),
        description: this.$t(`${path}[${i}].description`, this.variables)
      }))

      if (this.showTwoForOneCampaign && !this.isWomenOnePager) {
        enrichedItems[0] = {
          title: this.$t('FAQ.Topics.10.Description', this.variables),
          description: this.$t('FAQ.Topics.10.Questions.0.Answer', this.variables)
        }
      }

      if (this.isSpecialDesign) {
        const extraSpecialDesignItems = [
          {
            title: this.$t('SpecialDesigns.general.FAQ.FirstQuestion.Title', this.variables),
            description: this.$t('SpecialDesigns.general.FAQ.FirstQuestion.Description', this.variables)
          },
          {
            title: this.$t('SpecialDesigns.general.FAQ.SecondQuestion.Title', this.variables),
            description: this.$t('SpecialDesigns.general.FAQ.SecondQuestion.Description', this.variables)
          }
        ]

        return [...extraSpecialDesignItems, ...enrichedItems]
      }

      return enrichedItems
    },
    designName () {
      return capitalize(this.designSlug)
    },
    boxershortPostfix () {
      return [NewOrientations.men, NewOrientations.boys].includes(this.orientation) ? '-boxershort' : ''
    },
    heroImage () {
      return getImagePaths({
        s3: true,
        path: `/images/design-women/${this.secondaryDesignSlug}/signup/${this.secondaryDesignSlug}-header`
      })
    },
    specialDesignHeroImage () {
      return getImagePaths({
        s3: true,
        path: `/images/design/${this.fixedDesignSlug}/hero`
      })
    },
    productImage () {
      if (this.isWomenOnePager) {
        return getImagePaths({
          s3: true,
          path: `/images/design-women/${this.designSlug}/products/${this.designSlug}-women-bralette`,
          noMobile: true
        })
      }

      return getImagePaths({
        s3: true,
        path: `/images/design/${this.designSlug}/products/${this.designSlug}-${this.productGroup}${this.boxershortPostfix}`,
        noMobile: true
      })
    },
    secondaryProductImage () {
      return getImagePaths({
        s3: true,
        path: `/images/design-women/${this.secondaryDesignSlug}/products/${this.secondaryDesignSlug}-women-hipster`,
        noMobile: true
      })
    },
    mysteryImage () {
      return getImagePaths({
        s3: true,
        path: `/images/design/mystery/check-out/mystery-${this.orientation}${this.boxershortPostfix}`,
        noMobile: true
      })
    },
    specialDesignLogoImage () {
      return getImagePaths({
        s3: true,
        path: `/images/design/${this.fixedDesignSlug}/logo-info-wit`,
        noMobile: true
      })
    },
    modelImage () {
      if (this.isWomenOnePager) {
        return getImagePaths({
          s3: true,
          path: `/images/design-women/${this.secondaryDesignSlug}/signup/${this.secondaryDesignSlug}-model`,
          noMobile: true
        })
      }

      const membershipTypeUrl = getMembershipTypeUrl(this.form.freeMembershipType)

      return getImagePaths({
        s3: true,
        path: `/images/design/${this.designSlug}/signup/${this.designSlug}-${membershipTypeUrl}-model`,
        noMobile: true
      })
    },
    stickyATCText () {
      if (this.areAllFormsValid) {
        return this.$t('SignUp.StepFive.CompleteWithConsent', this.variables)
      }

      return this.getTranslation('TryForFree')
    },
    sizeOptions () {
      return this.getSizeOptions({ productGroup: this.isWomenOnePager ? Orientations.womenbralette : this.productGroup, membershipTypes: this.membershipTypes, designSlug: this.designSlug })
    },
    designColors () {
      return {
        primaryColor: `rgb(${this.designResponse?.primaryColor || '255,255,255'})`,
        secondaryColor: `rgb(${this.designResponse?.secondaryColor || '255,255,255'})`
      }
    },
    variables () {
      return {
        ...this.textVariables,
        design: this.designSlug ? capitalize(this.designSlug.replace('-', ' ')) : '',
        productGroup: this.productGroup ? this.productGroup.replace('-', ' ') : '',
        stockLeft: 10,
        stockStart: 3000,
        price: this.formattedPrice,
        twoForOnePrice: this.formattedTwoForOnePrice,
        product: this.$t(`Account.CancelMembershipForm.General.Product.${this.productGroup}-membership.Name`) || '',
        products: this.$t(`Account.CancelMembershipForm.General.Products.${this.productGroup}-membership.Name`) || '',
        freePrice: addLocalCurrency(0, this.country, this.currency),
        womenPrice: addLocalCurrency(WomenPrices[this.country] || 12.99, this.country, this.currency),
        partnershipCompany: this.isSpecialDesign ? this.$t(`SpecialDesigns.${this.fixedDesignSlug}.Company`) : '',
        partnership: this.isSpecialDesign ? this.$t(`SpecialDesigns.${this.fixedDesignSlug}.Partnership`) : ''
      }
    },
    price () {
      if (this.orientation === NewOrientations.women) {
        return WomenPrices[this.country]
      }

      if (this.orientation === NewOrientations.boys) {
        return BoysPrices[this.country]
      }

      if (this.orientation === NewOrientations.addon) {
        if (this.productGroup === Orientations.undershirts) {
          return UndershirtsPrices[this.country]
        }

        return SocksPrices[this.country]
      }

      return MenPrices[this.country]
    },
    formattedPrice () {
      return addLocalCurrency(this.price, this.country, this.currency)
    },
    showTwoForOneCampaign () {
      if (this.isWomenOnePager || this.isSpecialDesign) {
        return false
      }

      return this.showTwoForOneCampaignState
    },
    formattedTwoForOnePrice () {
      return addLocalCurrency(this.price * 2, this.country, this.currency)
    },
    formattedFreePrice () {
      return addLocalCurrency(0, this.country, this.currency)
    },
    currency () {
      if (!this.countriesData || !this.countriesData[this.country] || !this.countriesData[this.country].currency) {
        return Currencies[this.country]
      }

      return this.countriesData[this.country].currency
    },
    trialDurationInDays () {
      if (!this.countriesData || !this.countriesData[this.country] || !this.countriesData[this.country].trialDuration) {
        return 14
      }

      return this.countriesData[this.country].trialDuration
    },
    deliveryDates () {
      if (!this.countriesData || !this.countriesData[this.country] || !this.countriesData[this.country].dailyOrderDeliveryDate) {
        return {
          earliest: 4,
          latest: 7
        }
      }

      const date = this.$moment.utc(this.countriesData[this.country].dailyOrderDeliveryDate)
      const latest = date.diff(this.$moment.utc().startOf('day'), 'days')
      const earliest = latest - DaysToSubtractFromDeliveryDate

      return {
        earliest,
        latest
      }
    },
    showTabSlider () {
      return this.orientation === NewOrientations.men || this.orientation === NewOrientations.boys
    },
    isWomenOnePager () {
      return this.orientation === NewOrientations.women
    },
    isWomenOnePagerWithDesignChoice () {
      return this.onePagerType === OnePagerTypes.womenWithDesignChoice
    },
    isOnePagerWithDesignChoice () {
      return this.onePagerType === OnePagerTypes.withDesignChoice
    },
    isOnePagerWomenMinimal () {
      return this.onePagerType === OnePagerTypes.womenMinimal
    },
    isDynamicDesignOnePager () {
      return this.isWomenOnePagerWithDesignChoice || this.isOnePagerWithDesignChoice
    },
    countryData () {
      return this.countriesData ? (this.countriesData[this.country] || {}) : {}
    },
    ...mapState('app', {
      locale: state => state.locale,
      country: state => state.country,
      countriesData: state => state.countriesData
    }),
    ...mapState('signup', {
      form: state => state.form
    }),
    ...mapState('auth', {
      ipAddress: state => state.ipAddress
    }),
    ...mapGetters('flags', {
      showTwoForOneCampaignState: IS_TWO_FOR_ONE_CAMPAIGN
    }),
    ...mapState('specialDesigns', {
      specialDesigns: state => state.specialDesigns
    })
  },
  watch: {
    tabSliderMode (mode) {
      if (mode === modes.gifts) { // men originals
        this.setSignupFormField({ key: 'membershipType', value: MembershipTypes.menOriginals })
        this.setSignupFormField({ key: 'freeMembershipType', value: MembershipTypes.menOriginals })

        this.resetSizes({ type: 'primary' })

        if (this.orientationSliderMode !== modes.gifts) { // set other tabslider also to men originals
          this.orientationSliderMode = modes.gifts
        }
      } else { // boys originals
        this.setSignupFormField({ key: 'membershipType', value: MembershipTypes.boysOriginals })
        this.setSignupFormField({ key: 'freeMembershipType', value: MembershipTypes.boysOriginals })

        this.resetSizes({ type: 'primary' })
      }
    },
    orientationSliderMode (mode) {
      if (mode === modes.gifts) { // men originals
        this.setSignupFormField({ key: 'membershipType', value: MembershipTypes.menOriginals })
        this.setSignupFormField({ key: 'freeMembershipType', value: MembershipTypes.menOriginals })

        const potentialNewSizeReference = this.sizeReference.replace(MembershipTypes.menOne.replace('-membership', ''), MembershipTypes.menOriginals.replace('-membership', ''))
        const isSizeAvailableInFixedDesign = getMembershipTypeIsDesignAvailableInSpecificSize(this.membershipTypes, MembershipTypes.menOriginals.replace('-membership', ''), potentialNewSizeReference, this.fixedDesignSlug)

        if (isSizeAvailableInFixedDesign && !this.isCurrentDesignTheFixedDesign) {
          this.setSignupFormField({ key: 'design', value: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } })

          setTimeout(() => {
            this.slideDesignPicker(this.fixedDesignSlug)
          }, 200)
        } else if (!isSizeAvailableInFixedDesign) {
          const designWithMostStock = getMembershipTypeDesignWithMostStockInSpecificSize(this.membershipTypes, MembershipTypes.menOriginals.replace('-membership', ''), potentialNewSizeReference)

          this.setSignupFormField({ key: 'design', value: { name: designWithMostStock.name, slug: designWithMostStock.reference } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: designWithMostStock.name, slug: designWithMostStock.reference } })

          setTimeout(() => {
            this.slideDesignPicker(designWithMostStock.reference)
          }, 200)
        }

        this.setSignupFormField({ key: 'size', value: { label: this.form.size.label, reference: potentialNewSizeReference } })
        this.setSignupFormField({ key: 'freeSize', value: { label: this.form.freeSize.label, reference: potentialNewSizeReference } })
      } else { // men one
        this.setSignupFormField({ key: 'membershipType', value: MembershipTypes.menOne })
        this.setSignupFormField({ key: 'freeMembershipType', value: MembershipTypes.menOne })

        const potentialNewSizeReference = this.sizeReference.replace(MembershipTypes.menOriginals.replace('-membership', ''), MembershipTypes.menOne.replace('-membership', ''))
        const isSizeAvailableInFixedDesign = getMembershipTypeIsDesignAvailableInSpecificSize(this.membershipTypes, MembershipTypes.menOne.replace('-membership', ''), potentialNewSizeReference, this.fixedDesignSlug)

        if (isSizeAvailableInFixedDesign && !this.isCurrentDesignTheFixedDesign) {
          this.setSignupFormField({ key: 'design', value: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } })

          setTimeout(() => {
            this.slideDesignPicker(this.fixedDesignSlug)
          }, 200)
        } else if (!isSizeAvailableInFixedDesign) {
          const designWithMostStock = getMembershipTypeDesignWithMostStockInSpecificSize(this.membershipTypes, MembershipTypes.menOne.replace('-membership', ''), potentialNewSizeReference)

          this.setSignupFormField({ key: 'design', value: { name: designWithMostStock.name, slug: designWithMostStock.reference } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: designWithMostStock.name, slug: designWithMostStock.reference } })

          setTimeout(() => {
            this.slideDesignPicker(designWithMostStock.reference)
          }, 200)
        }

        this.setSignupFormField({ key: 'size', value: { label: this.form.size.label, reference: potentialNewSizeReference } })
        this.setSignupFormField({ key: 'freeSize', value: { label: this.form.freeSize.label, reference: potentialNewSizeReference } })
      }
    },
    currentDesignGroup: {
      immediate: true,
      handler (newGroup, oldGroup) {
        if (!newGroup || (newGroup && oldGroup && newGroup === oldGroup) || !this.isWomenOnePager) {
          return
        }

        const firstDesignWithNewGroup = this.secondaryDesignsToPick.find(design => design.designGroup === newGroup)

        if (firstDesignWithNewGroup) {
          if (!this.secondarySizeReference || this.secondaryCurrentDesignGroup !== newGroup) {
            this.setSignupFormField({
              key: Orientations.womenhipster,
              value: {
                ...this.form[Orientations.womenhipster],
                ...{ design: { name: firstDesignWithNewGroup.name, slug: firstDesignWithNewGroup.reference } }
              }
            })

            setTimeout(() => {
              this.secondarySlideDesignPicker(firstDesignWithNewGroup.reference)
            }, 200)
          }
        }
      }
    }
  },
  async mounted () {
    this.startCountdown()
    this.startAreAllFormsValidInterval()
    window.addEventListener('scroll', this.handleScroll)

    const promotionCode = this.$cookies.get(PromotionCodeCookie) || this.$route.query.code

    if (promotionCode) {
      await this.trySetPromotionCode({ promotionCode, silent: true })
    }
  },
  beforeDestroy () {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }

    if (this.areAllFormsValidInterval) {
      clearInterval(this.areAllFormsValidInterval)
    }

    window.removeEventListener('scroll', this.handleScroll)
  },
  created () {
    Object.keys(this.addressFormData.address).forEach((field) => {
      this.addressFormData.address[field] = this.form.address[field]
    })

    if (this.addressFormData.address.street && this.addressFormData.address.city) {
      this.alwaysShowAddressForm = true
    }
  },
  methods: {
    async trySetPromotionCode ({ promotionCode, silent = false }) {
      try {
        this.couponCodeErrors = null
        this.couponCodeLoading = true
        const isCorrectPromoCode = Object.values(PromoCodesByVendor).some(vendorCodes => vendorCodes.includes(promotionCode.toUpperCase().trim()))

        if (isCorrectPromoCode) {
          this.setSignupFormField({ key: 'promotionCode', value: promotionCode })

          if (!silent) {
            this.$refs.promotionCodeModal.onModalClose()
          }

          this.couponCodeLoading = false
        } else if (!silent) {
          await setTimeout(() => {
            this.couponCodeLoading = false
            this.couponCodeErrors = {
              couponCode: { populatedError: this.$t('SignUp.StepFive.PromoCodeIncorrect') }
            }
            this.$otoaster.danger(this.$t('SignUp.StepFive.PromoCodeUnknown'))
          }, 2000)
        } else if (silent) {
          this.couponCodeLoading = false
        }
      } catch (error) {
        const errors = this.getPopulatedErrors(error)

        if (errors) {
          this.couponCodeErrors = errors
        } else {
          this.$ota.general.logError(error)
        }

        this.couponCodeLoading = false
      }
    },
    async onReceivePaymentNonce (nonce) {
      this.paymentMethodNonce = nonce

      await this.onSubmit()
    },
    async submitPayment () {
      this.loading = true

      const category = this.isWomenOnePager ? 'women' : 'men'
      const baseUrl = `${process.env.BASE_URL}/${category}/signup/create-account/verification-payment`

      const queryParams = serializeParameters({
        prospectId: this.form.prospectId
      })

      const successUrl = `${baseUrl}/success?${queryParams}${this.isV2ThankYouPageVariant ? '&v=2' : ''}`
      const pendingUrl = `${baseUrl}/pending`
      const failedUrl = `${baseUrl}/failed`
      const declinedUrl = `${baseUrl}/declined`

      try {
        const { redirectUrl } = await this.createVerificationPayment({
          paymentType: this.selectedMethod.paymentType,
          ...(this.selectedIssuer ? { issuerId: this.selectedIssuer.value } : {}),
          ...(this.paymentMethodNonce ? { paymentMethodNonce: this.paymentMethodNonce } : {}),
          ...(this.deviceData ? { deviceData: this.deviceData } : {}),
          language: this.locale,
          successUrl,
          pendingUrl,
          failedUrl,
          declinedUrl,
          prospectId: this.form.prospectId,
          externalIdentifier: this.externalIdentifier,
          billingMetadata: this.billingMetadata
        })

        this.setSignupFormField({ key: 'paymentId', value: 'mockId' })

        this.$cookies.remove(PersistentStorageKeys.webshop)
        this.$cookies.remove(PersistentStorageKeys.general)

        window.location.href = redirectUrl
      } catch (e) {
        const emailAddressAlreadyKnown = !!e?.response?.data?.errors?.some(error => error?.message?.includes('There is already a user with email address'))

        if (emailAddressAlreadyKnown) {
          this.$otoaster.danger(this.$t('SignUp.Form.emailAlreadyUsed'))
        } else {
          this.$otoaster.danger(this.$t('Error.general'))
        }

        this.$ota.general.logError(e)
        this.submitLoading = false
      }
    },
    async onSubmit () {
      try {
        pushToDataLayer({ event: 'one_page_signup_form_submitted' })

        if (!this.form.design.slug) {
          this.setSignupFormField({ key: 'design', value: { name: this.designSlug.replace('-', ' '), slug: this.designSlug } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: this.designSlug.replace('-', ' '), slug: this.designSlug } })
        }

        if (!this.sizeReference) {
          this.$refs.size.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })

          setTimeout(() => {
            try {
              // display error message
              this.$refs.buttonPicker.submit()
            } catch (error) {
            }
          }, 600)

          if (!this.isWomenOnePager) {
            setTimeout(() => {
              const element = document.querySelector('.programatic-size-select .v-select.select input')

              if (element) {
                element.click()
                element.focus()
              }
            }, 2000)
          }
          return
        }

        if (this.isWomenOnePager && !this.secondarySizeReference) {
          this.$refs.secondarySize.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })

          setTimeout(() => {
            try {
            // display error message
              this.$refs.secondaryButtonPicker.submit()
            } catch (error) {
            }
          }, 600)

          return
        }

        const accountFormOne = this.$refs.createAccountFormOne
        accountFormOne.$v.$touch()

        const accountFormTwo = this.$refs.createAccountFormTwo
        accountFormTwo.$v.$touch()

        const addressForm = this.$refs.addressForm
        addressForm.$v.$touch()

        if (accountFormOne.$v.$invalid) {
          accountFormOne.invalidForm = true
          this.$refs.account.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })

          this.focusEmailField()
          return
        }

        ['email', 'password'].forEach((key) => {
          if (accountFormOne.formData[key]) {
            this.setSignupFormField({ key, value: accountFormOne.formData[key] })
          }
        })

        if (!accountFormTwo.formData.firstName) {
          accountFormTwo.invalidForm = true
          this.$refs.address.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          return
        }

        if (accountFormTwo.$v.$invalid) {
          accountFormTwo.invalidForm = true
          this.$refs.address.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          return
        }

        ['firstName', 'lastName'].forEach((key) => {
          if (accountFormTwo.formData[key]) {
            this.setSignupFormField({ key, value: accountFormTwo.formData[key] })
          }
        })

        if (!this.form.address.street) {
          this.$refs.address.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          return
        }

        if (addressForm.$v.$invalid) {
          addressForm.invalidForm = true
          this.$refs.address.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          return
        }

        if (this.buttonProps.disabled) {
          this.$otoaster.info(this.getTranslation('AddPaymentMethod'))
          this.$refs.payment.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
          return
        }

        if (!this.form.consent) {
          this.$otoaster.info(this.getTranslation('ConsentRequired'))
          this.$refs.payment.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
          this.$refs.paymentFormComponent.triggerConsentError()
          return
        }

        this.submitLoading = true

        let productGroupSizeDesigns = [
          {
            productGroupSize: `${idPrefixes.productGroupSizes}${this.form.size.reference}`,
            freeProductGroupSize: `${idPrefixes.productGroupSizes}${this.form.freeSize.reference}`,
            freeProductDesign: `${idPrefixes.designReference}${this.form.freeDesign.slug}`
          }
        ]

        if (this.isWomenOnePager) {
          productGroupSizeDesigns = getWomenProductGroupSizeDesigns(this.form)
        }

        if (!this.form.prospectId) {
          const everflowTransactionID = this.$cookies.get(EverflowClientCookie)
          const everflowSubIDs = this.$cookies.get(EverflowClientSubIDCookie)
          const everflowSourceID = this.$cookies.get(EverflowClientSourceIDCookie)
          const everflowAffiliateID = this.$cookies.get(EverflowClientAffiliateIDCookie)
          const scCid = this.$cookies.get(SnapchatClickIdCookie)
          const utmCampaign = this.$cookies.get(UTMCampaignCookie)
          const utmMedium = this.$cookies.get(UTMMediumCookie)

          const uuid = await this.createProspect({
            ...this.form,
            country: this.country,
            everflowSubIDs,
            everflowTransactionID,
            membershipType: `${this.productGroup}-membership`,
            productGroupSizeDesigns,
            everflowSourceID,
            everflowAffiliateID,
            scCid,
            utmCampaign,
            utmMedium,
            waitDays: this.waitDaysValue,
            signupThankYouPageVariant: this.signupThankYouPageVariantValue,
            promotionalEmailsEnabled: this.optinEnhancedValue
          })

          this.setSignupFormField({ key: 'prospectId', value: uuid })
          pushToDataLayer({ prospectId: uuid, event: 'one_page_signup_prospect_created' })
        } else {
          await this.updateProspectMembership({
            membershipType: `${this.productGroup}-membership`,
            productGroupSizeDesigns,
            prospectId: this.form.prospectId
          })

          await this.updateProspectAccount({
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            email: this.form.email,
            password: this.form.password,
            prospectId: this.form.prospectId,
            promotionalEmailsEnabled: this.optinEnhancedValue
          })
        }

        const updateAddressPayload = {
          address: { ...this.form.address, country: this.country },
          prospectId: this.form.prospectId
        }

        await this.updateProspectAddress(updateAddressPayload)

        this.setAddressConfirmed(true)

        if (this.form.promotionCode) {
          await this.useCouponCode({ prospectId: this.form.prospectId, couponCode: this.form.promotionCode })
        }

        await this.submitPayment()
      } catch (e) {
        const errors = this.getPopulatedErrors(e)
        const oldErrorsStyle = this.$ota.general.getRESTCustomErrorMessages(e.response?.data?.violations)

        const isAccountError = errors && ['email', 'password'].some(property => errors.hasOwnProperty(property))

        if (isAccountError) {
          this.$refs.account.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        } else if (oldErrorsStyle) {
          this.$refs.address.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          this.oldErrors = oldErrorsStyle || {}
        }

        if (errors) {
          this.errors = errors
        } else {
          this.$otoaster.danger(this.$t('Error.general'))
          this.$ota.general.logError(e)
        }

        if (this.isSpecialDesign && errors?.email?.locizeKey === 'Api.email.used') {
          this.openOutOfStockModal(this.sizeReference, true)
        }

        this.submitLoading = false
      }
    },
    openModal () {
      this.$refs.promotionCodeModal.toggleActivation(true)
    },
    capitalize (str) {
      return capitalize(str)
    },
    onConsentChange (consent) {
      this.setSignupFormField({ key: 'consent', value: consent })
    },
    onOptInChange (optIn) {
      this.setSignupFormField({ key: 'optIn', value: optIn })
    },
    slideDesignPicker (designSlug) {
      const designIndex = this.designsToPick.findIndex(design => design.reference === designSlug)

      if (designIndex !== -1 && this.$refs.designPicker) {
        this.$refs.designPicker.$refs.carousel.goTo(designIndex)
      }
    },
    secondarySlideDesignPicker (designSlug) {
      const designIndex = this.secondaryDesignsToPick.findIndex(design => design.reference === designSlug)

      if (designIndex !== -1 && this.$refs.secondaryDesignPicker) {
        this.$refs.secondaryDesignPicker.$refs.carousel.goTo(designIndex)
      }
    },
    changeCountry (country) {
      const newUrl = this.$route.fullPath.replace(stripLanguageRegex, `/${this.locale}-${country}`)

      this.$moment.locale(country)
      this.setCountry(country)

      this.$cookies.set(CCOUNTRY, country, {
        path: '/',
        maxAge: cookieConfig.maxAge,
        domain: getCookieDomain()
      })

      window.history.replaceState({}, '', `${process.env.BASE_URL}${newUrl}`)
    },
    handleScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      this.isStickyATCVisible = !!(currentScrollPosition > 500 && currentScrollPosition)
    },
    onReceiptClick () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    onDesignClick (design) {
      if (this.isWomenOnePager) {
        this.setSignupFormField({
          key: Orientations.womenbralette,
          value: {
            ...this.form[Orientations.womenbralette],
            ...{ design: { name: design.name, slug: design.reference } }
          }
        })

        return
      }

      this.setSignupFormField({ key: 'design', value: { name: design.name, slug: design.reference } })
      this.setSignupFormField({ key: 'freeDesign', value: { name: design.name, slug: design.reference } })
    },
    onSecondaryDesignClick (design) {
      this.setSignupFormField({
        key: Orientations.womenhipster,
        value: {
          ...this.form[Orientations.womenhipster],
          ...{ design: { name: design.name, slug: design.reference } }
        }
      })
    },
    toggleSizeChart (open) {
      this.$refs.sizeChartModal.toggleActivation(open)
    },
    braletteSizeChartClick () {
      this.$refs.WomenSizeChartModal.toggleBralette()
    },
    hipsterSizeChartClick () {
      this.$refs.WomenSizeChartModal.toggleHipster()
    },
    setAddressSuggestion (address) {
      this.errors = {}

      Object.entries(address).forEach(([key, value]) => {
        // Set to vuex state
        this.setAddressFormField({ key, value })

        // Set to address check mixin state
        this.addressFormData.address[key] = value
      })
    },
    onSizeChartButtonClick () {
      if (this.isWomenOnePager) {
        this.braletteSizeChartClick()

        return
      }

      this.toggleSizeChart(true)
    },
    openOutOfStockModal (productGroupSize = '', showSecondaryTexts = false) {
      this.$refs.SignupOutOfStockModal.toggleActivation(productGroupSize, showSecondaryTexts, this.form.email, this.form.firstName, this.form.lastName)
    },
    trackSizeSelect ({ sizeReference, sizeLabel, inStock = true, isFallback = false } = {}) {
      try {
        const signupType = this.isDynamicDesignOnePager ? 'dynamic_design' : 'fixed_design'

        const payload = {
          sizeReference,
          sizeLabel,
          orientation: this.orientation,
          country: this.country,
          inStock,
          isFallback,
          signupType,
          url: window.location.href
        }

        datadogRum.addAction('signup_size_select', payload)

        pushToDataLayer({ ...payload, event: 'signup_size_selection', event_action: 'signup_size_selected' })
      } catch {}
    },
    onSizeSelectCheckToScroll () {
      if (!this.sizeReference) {
        if (this.isOnePagerWithDesignChoice) {
          setTimeout(() => {
            this.$refs.design.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }, 1500)
        } else if (this.isWomenOnePagerWithDesignChoice && this.secondarySizeReference) {
          setTimeout(() => {
            this.$refs.design.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }, 1500)
        } else if (!this.isWomenOnePager || this.secondarySizeReference) {
          setTimeout(() => {
            this.$refs.account.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }, 1500)

          this.focusEmailField()
        } else if (this.isWomenOnePager && !this.secondarySizeReference) {
          setTimeout(() => {
            this.$refs.secondarySize.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 1500)
        }
      }
    },
    onSizeSelect ($event) {
      if (this.isWomenOnePager) {
        const isSizeAvailableInFixedDesign = getMembershipTypeIsDesignAvailableInSpecificSize(this.membershipTypes, Orientations.womenbralette, $event.value, this.fixedDesignSlug)

        if (!isSizeAvailableInFixedDesign) {
          const designWithMostStock = getMembershipTypeDesignWithMostStockInSpecificSize(this.membershipTypes, Orientations.womenbralette, $event.value)

          if (!designWithMostStock || !designWithMostStock.name || !designWithMostStock.reference) {
            this.openOutOfStockModal($event.value, false)
            this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: false, isFallback: true })
            return
          }

          this.setSignupFormField({
            key: Orientations.womenbralette,
            value: {
              ...this.form[Orientations.womenbralette],
              ...{ design: { name: designWithMostStock.name, slug: designWithMostStock.reference } }
            }
          })
        }

        this.setSignupFormField({
          key: Orientations.womenbralette,
          value: {
            ...this.form[Orientations.womenbralette],
            ...{ size: { label: $event.label, reference: $event.value } }
          }
        })

        if (!this.isCurrentDesignTheFixedDesign && isSizeAvailableInFixedDesign) {
          this.setSignupFormField({
            key: Orientations.womenbralette,
            value: {
              ...this.form[Orientations.womenbralette],
              ...{ design: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } }
            }
          })
        }

        if (isSizeAvailableInFixedDesign) {
          this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: true })
        } else {
          this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: true, isFallback: true })
        }
      } else {
        const isSizeAvailableInFixedDesign = getMembershipTypeIsDesignAvailableInSpecificSize(this.membershipTypes, this.productGroup, $event.value, this.fixedDesignSlug)

        if (!isSizeAvailableInFixedDesign) {
          const designWithMostStock = getMembershipTypeDesignWithMostStockInSpecificSize(this.membershipTypes, this.productGroup, $event.value)

          if (!designWithMostStock || !designWithMostStock.name || !designWithMostStock.reference) {
            this.openOutOfStockModal($event.value, false)
            this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: false, isFallback: true })
            return
          }

          this.setSignupFormField({ key: 'design', value: { name: designWithMostStock.name, slug: designWithMostStock.reference } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: designWithMostStock.name, slug: designWithMostStock.reference } })
        }

        this.setSignupFormField({ key: 'size', value: { label: $event.label, reference: $event.value } })
        this.setSignupFormField({ key: 'freeSize', value: { label: $event.label, reference: $event.value } })

        if (!this.isCurrentDesignTheFixedDesign && isSizeAvailableInFixedDesign) {
          this.setSignupFormField({ key: 'design', value: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } })
          this.setSignupFormField({ key: 'freeDesign', value: { name: capitalize(this.fixedDesignSlug.replace('-', ' ')), slug: this.fixedDesignSlug } })
        }

        if (isSizeAvailableInFixedDesign) {
          this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: true })
        } else {
          this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: true, isFallback: true })
        }
      }

      this.onSizeSelectCheckToScroll()

      if (this.isOnePagerWithDesignChoice || this.isWomenOnePagerWithDesignChoice) {
        setTimeout(() => {
          this.slideDesignPicker(this.designSlug)
        }, 200)
      }
    },
    focusEmailField () {
      setTimeout(() => {
        this.$refs.account.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })

        const emailElement = document.getElementById('email')

        if (emailElement) {
          emailElement.focus()
        }
      }, 1200)
    },
    resetSizes ({ type = 'primary' } = {}) {
      if (type === 'primary') {
        if (this.isWomenOnePager) {
          this.setSignupFormField({
            key: Orientations.womenbralette,
            value: {
              ...this.form[Orientations.womenbralette],
              ...{ size: { label: null, reference: null } }
            }
          })

          return
        }

        this.setSignupFormField({ key: 'size', value: { label: null, reference: null } })
        this.setSignupFormField({ key: 'freeSize', value: { label: null, reference: null } })
      } else if (type === 'secondary') {
        this.setSignupFormField({
          key: Orientations.womenhipster,
          value: {
            ...this.form[Orientations.womenhipster],
            ...{ size: { label: null, reference: null } }
          }
        })
      }
    },
    onSecondarySizeSelectCheckToScroll () {
      if (!this.secondarySizeReference) {
        if (this.isWomenOnePagerWithDesignChoice) {
          if (!this.sizeReference) {
            setTimeout(() => {
              this.$refs.size.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 1500)
          } else {
            setTimeout(() => {
              this.$refs.design.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              })
            }, 1500)
          }
        } else if (!this.sizeReference && this.isWomenOnePager) {
          setTimeout(() => {
            this.$refs.size.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 1500)
        } else {
          this.focusEmailField()
        }
      }
    },
    onSecondarySizeSelect ($event) {
      if (this.isWomenOnePager) {
        const isSizeAvailableInFixedDesign = getMembershipTypeIsDesignAvailableInSpecificSize(this.membershipTypes, Orientations.womenhipster, $event.value, this.secondaryFixedDesignSlug)

        if (!isSizeAvailableInFixedDesign) {
          const designWithMostStock = getMembershipTypeDesignWithMostStockInSpecificSize(this.membershipTypes, Orientations.womenhipster, $event.value)

          if (!designWithMostStock || !designWithMostStock.name || !designWithMostStock.reference) {
            this.openOutOfStockModal($event.value, false)
            this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: false, isFallback: true })
            return
          }

          this.setSignupFormField({
            key: Orientations.womenhipster,
            value: {
              ...this.form[Orientations.womenhipster],
              ...{ design: { name: designWithMostStock.name, slug: designWithMostStock.reference } }
            }
          })
        }

        this.setSignupFormField({
          key: Orientations.womenhipster,
          value: {
            ...this.form[Orientations.womenhipster],
            ...{ size: { label: $event.label, reference: $event.value } }
          }
        })

        if (isSizeAvailableInFixedDesign) {
          this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: true })
        } else {
          this.trackSizeSelect({ sizeReference: $event.value, sizeLabel: $event.label, inStock: true, isFallback: true })
        }
      }

      this.onSecondarySizeSelectCheckToScroll()

      if (this.isWomenOnePagerWithDesignChoice) {
        setTimeout(() => {
          this.secondarySlideDesignPicker(this.secondaryDesignSlug)
        }, 200)

        setTimeout(() => {
          if (this.currentDesignGroup !== this.secondaryCurrentDesignGroup) {
            const firstDesignWithNewGroup = this.designsToPick.find(design => design.designGroup === this.secondaryCurrentDesignGroup)
            if (firstDesignWithNewGroup) {
              this.setSignupFormField({
                key: Orientations.womenbralette,
                value: {
                  ...this.form[Orientations.womenbralette],
                  ...{ design: { name: firstDesignWithNewGroup.name, slug: firstDesignWithNewGroup.reference } }
                }
              })

              setTimeout(() => {
                this.slideDesignPicker(firstDesignWithNewGroup.reference)
              }, 200)
            }
          }
        }, 200)
      }
    },
    onAddressChange ({ field, address }) {
      this.setAddressConfirmed(false)
      this.setAddressFormField({ key: field, value: address[field] })
    },
    focusLoqate () {
      if (this.$device.isMobile) {
        this.$refs.addressForm?.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    formatErrors (errors) {
      return Object.values(errors).reduce((acc, error) => ({
        ...acc,
        [error.propertyPath]: error.populatedError
      }), {})
    },
    getTranslation (key) {
      return this.$t(`SignUp.OnePage.${key}`, this.variables)
    },
    deletePromoCode () {
      this.setSignupFormField({ key: 'promotionCode', value: '' })
    },
    startCountdown () {
      this.countdownInterval = setInterval(() => {
        if (this.timeRemaining > 0) {
          const newTimeRemaining = this.timeRemaining - 1
          this.timeRemaining = newTimeRemaining

          this.$cookies.set(OTACountdownCookie, newTimeRemaining, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
        } else {
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    },
    onDisabledDesignPickerClick () {
      if (!this.sizeReference) {
        this.$refs.size.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })

        setTimeout(() => {
          try {
            // display error message
            this.$refs.buttonPicker.submit()
          } catch (error) {
          }
        }, 600)

        return
      }

      if (this.isWomenOnePager && !this.secondarySizeReference) {
        this.$refs.secondarySize.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })

        setTimeout(() => {
          try {
          // display error message
            this.$refs.secondaryButtonPicker.submit()
          } catch (error) {
          }
        }, 600)
      }
    },
    startAreAllFormsValidInterval () {
      this.areAllFormsValidInterval = setInterval(() => {
        const hasSizeSelected = !!this.sizeReference

        const accountFormOneIsValid = !this.$refs.createAccountFormOne?.$v.$invalid

        const accountFormTwoIsValid = !this.$refs.createAccountFormTwo?.$v.$invalid

        const addressFormIsValid = !this.$refs.addressForm?.$v.$invalid

        this.areAllFormsValid = hasSizeSelected && accountFormOneIsValid && accountFormTwoIsValid && addressFormIsValid
      }, 2000)
    },
    rightOfWithdrawal () {
      this.$refs.RightOfWithdrawalModal.toggleActivation(true)
    },
    termsAndConditions () {
      this.$refs.TermsAndConditionsModal.toggleActivation(true)
    },
    privacyStatement () {
      this.$refs.PrivacyStatementModal.toggleActivation(true)
    },
    termsOfUse () {
      this.$refs.TermsofUseModal.toggleActivation(true)
    },
    truncateText (text = '', maxWords = 11) {
      const words = text.split(' ')
      if (words.length > maxWords) {
        return words.slice(0, maxWords).join(' ') + '...'
      }
      return text
    },
    toggleReadMore (property = 'bralette') {
      this.readMore = {
        ...this.readMore,
        [property]: !this.readMore[property]
      }
    },
    getSizeOptions ({ productGroup, membershipTypes, designSlug } = {}) {
      if (membershipTypes.length) {
        return groupMembershipTypesSizesForDesign(membershipTypes, designSlug)[productGroup]
      }

      return []
    },
    getDesignsToPick ({ productGroup = Orientations.menoriginals, sizeReference }) {
      if (productGroup && sizeReference) {
        return groupMembershipTypeAvailableDesigns(this.membershipTypes, sizeReference, productGroup)
      }

      return this.designsToPick
    },
    ...mapMutations('signup', {
      setSignupFormField: SET_FORM_FIELD,
      setAddressConfirmed: SET_ADDRESS_CONFIRMED,
      setAddressFormField: SET_ADDRESS_FORM_FIELD
    }),
    ...mapActions('signup', {
      useCouponCode: SIGNUP_USE_COUPON_CODE,
      createVerificationPayment: SIGNUP_CREATE_VERIFICATION_PAYMENT,
      createProspect: SIGNUP_CREATE_PROSPECT,
      updateProspectMembership: SIGNUP_UPDATE_MEMBERSHIP_TYPE,
      updateProspectAccount: SIGNUP_UPDATE_PROSPECT_ACCOUNT,
      updateProspectAddress: SIGNUP_UPDATE_PROSPECT_ADDRESS
    }),
    ...mapMutations('app', {
      setCountry: SET_COUNTRY
    })
  }
}
</script>

<style scoped lang="postcss">
.men-one-page-signup {
  .product-image-container {
    @apply px-14 py-6;
  }

  .custom-opt-in {
    >>> .ocheckbox {
      margin-top: .4rem;
      height: 1rem;
      width: 1rem;
    }

    >>> .ocheckbox-checked {
      .ocheckbox-box {
        height: .6rem;
        width: .6rem;
      }
    }

    >>> .opt-in-label {
      padding-left: .4rem;
    }
  }

  .o-heading-1 {
    line-height: 3.6rem;
  }

  .special-design-info {
    border-radius: .6rem;
  }

  .max-w-375 {
    @apply mx-auto;
    min-height: 27rem;
    max-width: 24.4rem;
  }

  .design-picker-container {
    &-cloak {
      @apply absolute top-0 right-0 left-0 bottom-0 pointer-events-none;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.7) 50.48%, rgba(255, 255, 255, 0.6) 100%);
    }
  }

  .address-form >>> hr {
    @apply hidden;
  }

  .banner-container {
    position: relative;
    width: 100%;
  }

  .banner-content {
    animation: slide 20s linear infinite;
    display: inline-flex;
  }

  .pick-size-texts {
    max-width: 23.2rem;
  }

  .women-pick-size-texts {
    margin-bottom: -3rem;

    &-image-container {
      margin-right: -4rem;

      >>> img {
        min-width: 19rem;
        width: 180px;
        height: 180px;
        object-fit: cover;
        object-position: center;
      }
    }
  }

  .sticky-atc {
    >>> .obutton {
      border-radius: 10rem !important;
    }
  }

  .tabslider-size {
    max-width: 16rem;
  }

  .product-image-overlay {
    right: -82%;
    max-width: 18.7rem;
  }

  .super-box {
    @apply border border-neutral-200 flex justify-center items-center p-1;
    min-width: 5rem;
    max-width: 5rem;
    min-height: 5rem;
    max-height: 5rem;
    border-radius: .2rem;

    >>> img {
      max-width: 3.2rem !important;
    }
  }

  .tabslider {
    >>> svg {
      @apply hidden;
    }
  }

  .negative-margin {
    margin-top: -3rem;
  }

  .promotion-code {
    >>> svg.checkmark-icon {
      @apply fill-white;
    }
  }

  .size-button {
    >>> svg {
      @apply w-6 mr-1;
    }

    >>> path {
      @apply fill-gray-600;
    }
  }

  &.two-for-one-campaign {
    >>> .product-image {
      @apply object-contain !important;
      margin-left: -6rem;
    }

    .product-image-text {
      right: -17%;
      top: 64%;
    }

    .plus-icon {
      @apply absolute text-white fill-black;
      width: 5.4rem;
      height: 5.4rem;
      top: 29%;
      right: 23%;
    }
  }

  &.is-women-one-pager {
    .super-box {
      >>> img {
        max-width: 5rem !important;
      }
    }

    .negative-margin {
      margin-top: -5rem;
    }

    .product-image-text {
      right: 1.6rem;
      top: 59%;
    }

    .sticky-receipt {
      >>> img {
        max-width: 3.4rem !important;
      }
    }
  }

  >>> {
    .product-image {
      @apply absolute;
      max-width: 24rem;
      min-height: calc(100vw - 112px);
    }

    .o-input-required-label {
      @apply hidden;
    }

    .mystery-image {
      @apply absolute;
      max-width: 15rem;
      top: -17%;
      right: -13%;
    }

    input#firstName, input#lastName {
      @apply mb-0;
    }

    .create-account-form-button {
      @apply hidden;
    }

    .free-text {
      @apply bg-green-400 px-2 py-half text-white;
    }

    .summary-box-block-edit-button {
      @apply hidden;
    }

    .button-group-container {
      gap: .5rem;
    }
  }

  .product-image-text {
    @apply absolute bg-green-400 px-2 py-half text-white uppercase z-30;
    border-radius: .6rem;
    font-size: 3rem;
    right: -16%;
    top: 62%;
  }

  .custom-padding {
    @apply px-7;
  }

  .meter-bar {
    @apply bg-yellow-50 relative;
    border-radius: 1rem;
    height: 21px;

    &-filler {
      @apply absolute left-0 h-full bg-yellow-600;
      border-radius: 1rem;
      width: 0%;
      -webkit-transition: width 1s ease-in-out;
      -moz-transition: width 1s ease-in-out;
      -o-transition: width 1s ease-in-out;
      transition: width 1s ease-in-out;
    }
  }

  >>> .special-design-hero-header {
    @apply absolute top-0 right-0 left-0 bottom-0 object-cover !important;
  }
}

.orange-badge {
  @apply text-orange-600;
  padding: .3rem 0;
  border-radius: .5rem;
}

@screen xsplus {
  .men-one-page-signup {
    >>> .product-image {
      min-height: unset;
    }
  }
}

@screen md {
  .men-one-page-signup {
    .negative-margin {
      margin-top: -7.3rem;
    }

    .product-image-container {
      @apply pb-14;
    }

    >>> {
      .product-image {
        max-width: 40rem !important;
        min-height: unset !important;
      }
    }
  }
}

@screen lg {
  .men-one-page-signup {
    .special-design-info {
      >>> .special-design-logo {
        min-width: 22rem;
      }
    }

    .product-image-container {
      padding: 5.6rem;
      @apply px-10;
      max-width: unset;
      max-height: 29rem;

      .first-half {
        border-top-left-radius: 2rem;
      }
    }

    .women-pick-size-texts {
      &-image-container {
        margin-right: -2rem;
      }
    }

    >>> [data-qa='signup-information'] {
      border-top-right-radius: 2rem;
    }

    .radius-corners-2 {
      border-bottom-right-radius: 2rem;
      border-top-right-radius: 2rem;
    }

    .max-w-375 {
      max-height: 14rem;
      min-height: unset !important;
    }

    .tabslider-size {
      min-width: 16rem;
    }

    .pick-size-texts {
      max-width: unset;
    }

    >>> {
      .manual-button-container {
        @apply justify-start;
      }

      .model-image {
        border-bottom-right-radius: 2rem;
      }

      .osignup-box-container {
        > div {
          overflow: unset;
        }

        .right-flex {
          overflow-x: unset;
        }
      }

      .meter-bar {
        height: .4rem;
      }

      .product-image {
        @apply relative z-20;
        margin-top: -6.5rem;
        max-width: 25.3rem !important;
      }
    }

    .product-image-text {
      right: -25%;
      top: 109%;
    }

    .custom-padding {
      padding: 0 1.7rem;
    }

    &.two-for-one-campaign {
      .product-image-container {
        @apply pt-7 px-10;
      }

      .banner-container {
        border-top-left-radius: 2rem;
      }

      .first-half {
        border-top-left-radius: 0;
      }

      >>> .product-image {
        @apply mx-auto;
        max-width: 22rem !important;
        margin-top: -4rem;
        left: -4rem;
      }

      .max-w-375 {
        max-height: 12rem;
        min-height: unset;
      }

      >>> .mystery-image {
        width: 17rem;
        max-width: 17rem;
        top: -16%;
        right: -21%;
        max-height: unset;
        height: unset;
      }

      .product-image-text {
        right: -30%;
        top: 115%;
      }

      .plus-icon {
        top: 37%;
        right: 19%;
        z-index: 20;
      }
    }

    &.is-women-one-pager {
      .product-image-text {
        right: 4rem;
        top: 53%;
      }
    }

    .women-hero-image-container {
      >>> img {
        border-top-left-radius: 2rem;
      }
    }

    >>> .special-design-hero-header {
      border-top-left-radius: 2rem;
    }
  }
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
